module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navBar"
  }, [_c('mt-tabbar', {
    staticClass: "nav",
    attrs: {
      "fixed": "fixed"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "home"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("首页")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "classify"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/classify"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-th-large",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("分类")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "cart"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shopping"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("购物车")])])], 1), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "user"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/personal"
    }
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("我的")])])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69a94b1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/navBar.vue
// module id = 225
// module chunks = 1